import React from 'react'
import loadComponent from 'src/utils/loadMFE'
import { useFlightDeck } from 'src/context/FlightDeckContext'
import RouteContainer from 'src/components/App/RouteContainer'

const UserWorkflowAssignTableList = React.lazy(() => loadComponent('traiwiss', 'UserWorkflowAssignTableList'))

export function UserWorkflowAssignIndexRoute() {
    const { academy } = useFlightDeck()

    return (
        <RouteContainer>
            <UserWorkflowAssignTableList title="User-Workflow Zuweisung" academyId={academy?._id} />
        </RouteContainer>
    )
}
